import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { DocumentGenerationFeature } from './selectors';
import {
  GenerateClauseListPayload,
  GenerateClauseListResponse,
  GenerateDocumentResponse,
} from '../services/document-generation-api.service';

export const DocumentGenerationActions = createActionGroup({
  source: DocumentGenerationFeature,
  events: {
    'Generate Clause List': props<{
      payload: GenerateClauseListPayload;
      createDocumentImmediately: boolean;
    }>(),
    'Generate Clause List Success': props<{
      payload: GenerateClauseListPayload;
      generateClauseListResponse: GenerateClauseListResponse;
    }>(),
    'Generate Clause List Failure': props<{
      payload: GenerateClauseListPayload;
    }>(),
    'Retry Generate Clause List': emptyProps(),
    'Generate Document': props<{ generateClauseListResponse: GenerateClauseListResponse }>(),
    'Set Generate Document Response': props<{
      generateDocumentResponse: GenerateDocumentResponse;
    }>(),
    'Generate Document Started': emptyProps(),
    'Start Asking Generate Document Status': emptyProps(),
    'Generate Document Success': props<{ generateDocumentResponse: GenerateDocumentResponse }>(),
    'Generate Document Failure': emptyProps(),
    'Generate Document Cancelled': emptyProps(),
    'Clear Generate Document Cancelled': emptyProps(),
    'Reset Generate Document Results': emptyProps(),
    'Close Generate Document Modal': emptyProps(),
  },
});
